import React from 'react';
import { formatUnreadHistoryBadge, getUnreadHistoryAriaLabel } from './orderHistoryUnreadStorage';
import './OrderHistoryModal.css';

/**
 * Info-column Order History control with optional unread count badge.
 * Preserves existing fa-history look; badge matches NOTES-style compact pills.
 */
const OrderHistoryIconButton = ({ unreadCount = 0, onClick, className = '' }) => {
    const count = Number(unreadCount) || 0;
    const label = getUnreadHistoryAriaLabel(count);
    const badgeText = formatUnreadHistoryBadge(count);

    return (
        <button
            type="button"
            className={`order-history-icon-btn ${className}`.trim()}
            onClick={onClick}
            title={label}
            aria-label={label}
            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', position: 'relative' }}
        >
            <i className="fa fa-history" aria-hidden="true" style={{ fontSize: '17px', color: '#6c757d' }} />
            {count > 0 && (
                <span className="order-history-unread-badge" aria-hidden="true">
                    {badgeText}
                </span>
            )}
        </button>
    );
};

export default OrderHistoryIconButton;
